import ReactPDF, { Image, Text, View } from "@react-pdf/renderer";
import { borderColor, styles } from "./styles";
import QRCode from "qrcode";
import { formatDate } from "../../../../utils/commonFunctions";
import { useEffect, useState } from "react";

type AppProps = {
  downloadRevenuesData: any;
  isFixed: boolean;
};

let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
let blobToken = process.env.REACT_APP_BLOB_TOEKN;

const BatchSummaryFromAndLogo = ({ downloadRevenuesData, isFixed }: AppProps) => {

  const [qrCode, setQrCode] = useState<File | undefined>()



  useEffect(() => {
    if (downloadRevenuesData?.signed_qr_Code) {
      (async () => {
        try {
          const qrDataUrl = await QRCode.toDataURL(downloadRevenuesData.signed_qr_Code);

          const dataURLtoFile = (dataUrl: string, filename: string): File | null => {
            if (!dataUrl) return null;

            const arr = dataUrl.split(',');
            const mimeMatch = arr[0].match(/:(.*?);/);
            if (!mimeMatch) return null;

            const mime = mimeMatch[1];
            const bstr = atob(arr[1]);
            const n = bstr.length;
            const u8arr = new Uint8Array(n);

            for (let i = 0; i < n; i++) {
              u8arr[i] = bstr.charCodeAt(i);
            }

            return new File([u8arr], filename, { type: mime });
          };

          const qrFile = dataURLtoFile(qrDataUrl, "qr-code.jpg");
          if (qrFile) {
            setQrCode(qrFile);
          } else {
            console.error('Failed to convert QR code to file');
          }
        } catch (error) {
          console.error('Error generating QR code:', error);
          // Consider adding error state handling here
        }
      })();
    }
  }, [downloadRevenuesData?.signed_qr_Code])

  function insertBreaks(str: any, interval: number = 15) {
    if (!str) return "";
    return str.match(new RegExp(`.{1,${interval}}`, 'g')).join('\n');
  }



  return (
    <View >
      {/* first column  */}
      <View style={styles.sub_header_1}>
        <View style={{ maxWidth: "40%" }}>
          {!!downloadRevenuesData?.primary_details?.logo_details?.file_url
            ?.length ? (
            <Image
              style={styles.image}
              src={`${blobBaseUrl}${downloadRevenuesData?.primary_details?.logo_details?.file_url}?${blobToken}`}
            />
          ) : null}
        </View>

        {downloadRevenuesData?.primary_details?.document_type?.label ? (
          <View style={{ maxWidth: "50%" }}>
            <Text style={styles.heading}>
              {downloadRevenuesData?.primary_details?.document_type?.label}
            </Text>
          </View>
        ) : null}
      </View>

      {/* second column  */}
      <View style={[{ ...styles.sub_header_1, flexDirection: "row", width: "100%" }]}>
        <View
          style={[
            {
              borderTop: `1px solid ${borderColor}`,
              borderBottom: `1px solid ${borderColor}`,
              borderLeft: `1px solid ${borderColor}`,
              flex: 1,
              padding: 8
            }]}
        >
          <Text
            style={{
              ...styles.sub_header,
              textAlign: "left",
              color: "#dd4433",
            }}
          >
            Bill From :{" "}
          </Text>

          {downloadRevenuesData?.primary_details?.bill_from?.trade_name ? (
            <Text style={{ ...styles.text, paddingVertical: "2px" }}>
              {downloadRevenuesData?.primary_details?.bill_from?.trade_name}
            </Text>
          ) : null}

          {downloadRevenuesData?.primary_details?.bill_from_address1 ||
            downloadRevenuesData?.primary_details?.bill_from_address2 ? (
            <Text style={styles.text}>
              {downloadRevenuesData?.primary_details?.bill_from_address1 +
                " " +
                downloadRevenuesData?.primary_details?.bill_from_address2}
            </Text>
          ) : null}
          {downloadRevenuesData?.primary_details?.cin_number ? (
            <View style={styles.flexCenter}>
              <Text style={styles.sub_header}>CIN No : </Text>
              <Text style={styles.text}>
                {downloadRevenuesData?.primary_details?.cin_number}
              </Text>
            </View>
          ) : null}
          <View
          // style={{
          //   alignItems: "flex-start",
          //   maxWidth: "40%",
          //   // marginTop: "-15px",
          //   borderTop: "1px solid red",
          // }}
          >
            {downloadRevenuesData?.primary_details?.business_address_details
              ?.pan_number ? (
              <View style={styles.flexCenter}>
                <Text style={styles.sub_header}>PAN No : </Text>

                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details
                      ?.business_address_details?.pan_number
                  }
                </Text>
              </View>
            ) : null}

            {downloadRevenuesData?.primary_details?.gst_number ? (
              <View style={styles.flexCenter}>
                <Text style={styles.sub_header}>GST : </Text>

                <Text style={styles.text}>
                  {downloadRevenuesData?.primary_details?.gst_number}
                </Text>
              </View>
            ) : null}

            {downloadRevenuesData?.primary_details?.business_address_details
              ?.mobile ? (
              <View style={styles.flexCenter}>
                <Text style={styles.sub_header}>Mobile No : </Text>
                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details
                      ?.business_address_details?.mobile
                  }
                </Text>
              </View>
            ) : null}
            {downloadRevenuesData?.primary_details?.business_address_details
              ?.pan ? (
              <View style={styles.flexCenter}>
                <Text style={styles.sub_header}>Pan : </Text>
                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details
                      ?.business_address_details?.pan
                  }
                </Text>
              </View>
            ) : null}

            {downloadRevenuesData?.primary_details?.business_address_details
              ?.email ? (
              <View style={styles.flexCenter}>
                <Text style={styles.sub_header}>Email : </Text>
                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details
                      ?.business_address_details?.email
                  }
                </Text>
              </View>
            ) : null}
            {downloadRevenuesData?.primary_details?.website ? (
              <View style={styles.flexCenter}>
                <Text style={styles.sub_header}>Website : </Text>
                <Text style={styles.text}>
                  {downloadRevenuesData?.primary_details?.website}
                </Text>
              </View>
            ) : null}


          </View>
        </View>


        <View
          style={[{
            border: `1px solid ${borderColor}`,
            flex: 1,
            padding: 8
          }]}
        >
          <Text style={{ ...styles.sub_header, color: "#dd4433" }}>
            Billing Address :{" "}
          </Text>
          {downloadRevenuesData?.primary_details?.customer_name
            ?.legal_name ? (
            <Text style={{ ...styles.text, paddingVertical: "2px" }}>
              {
                downloadRevenuesData?.primary_details?.customer_name
                  ?.legal_name
              }
            </Text>
          ) : null}

          {downloadRevenuesData?.primary_details?.customer_address1 ||
            downloadRevenuesData?.primary_details?.customer_address2 ? (
            <Text style={styles.text}>
              <Text>
                {downloadRevenuesData?.primary_details?.customer_address1 +
                  " " +
                  downloadRevenuesData?.primary_details?.customer_address2}
              </Text>
            </Text>
          ) : null}

          {downloadRevenuesData?.primary_details?.customer_gstn ? (
            <Text style={styles.flexCenter}>
              <Text style={styles.sub_header}>GST : </Text>
              <Text style={styles.text}>
                {downloadRevenuesData?.primary_details?.customer_gstn}
              </Text>
            </Text>
          ) : null}

          {downloadRevenuesData?.primary_details?.customer_supplier_details
            ?.pan_number ? (
            <Text style={styles.flexCenter}>
              <Text style={styles.sub_header}>PAN : </Text>
              <Text style={styles.text}>
                {
                  downloadRevenuesData?.primary_details
                    ?.customer_supplier_details?.pan_number
                }
              </Text>
            </Text>
          ) : null}

          {downloadRevenuesData?.primary_details?.customer_supplier_details
            ?.email ? (
            <Text style={styles.flexCenter}>
              <Text style={styles.sub_header}>Email : </Text>
              <Text style={styles.text}>
                {
                  downloadRevenuesData?.primary_details
                    ?.customer_supplier_details?.email
                }
              </Text>
            </Text>
          ) : null}

          {downloadRevenuesData?.primary_details?.customer_supplier_details
            ?.mobile ? (
            <Text style={styles.flexCenter}>
              <Text style={styles.sub_header}>Mobile : </Text>
              <Text style={styles.text}>
                {
                  downloadRevenuesData?.primary_details
                    ?.customer_supplier_details?.mobile
                }
              </Text>
            </Text>
          ) : null}
          {/* ////2nd */}
        </View>

      </View>

      {<View style={[{ ...styles.sub_header_1, flexDirection: "row", width: "100%" }]}>

        {downloadRevenuesData?.primary_details?.irn ? <View
          style={[{
            textAlign: "left",
            borderRight: `1px solid ${borderColor}`,
            borderLeft: `1px solid ${borderColor}`,
            borderBottom: `1px solid ${borderColor}`,
            flex: 1,
            padding: 8,
            gap: 10,
            ...styles.row
          }]}
        >
          {qrCode ? <View>
            <Image source={qrCode} style={styles.qr_image} />
          </View> : null}
          <View style={{ flexWrap: "wrap", maxWidth: "50%" }}>
            <Text style={styles.flexCenter}>
              <Text style={styles.sub_header}>Ack No: </Text>
              <Text style={styles.text}>{downloadRevenuesData?.ack_no}</Text>
            </Text>
            <Text style={styles.flexCenter}>
              <Text style={styles.sub_header}>Ack Date: </Text>
              <Text style={styles.text}>{downloadRevenuesData?.ack_date}</Text>
            </Text>
            <Text style={styles.flexCenter}>
              <Text style={styles.sub_header}>IRN No: </Text>
              <Text style={{ ...styles.text, wordBreak: "break-all", flexShrink: 1, maxWidth: "50%" }}>{insertBreaks(downloadRevenuesData?.primary_details?.irn, 45)}</Text>
            </Text>
          </View>
        </View> : null}



        <View
          style={[{
            textAlign: "left",
            borderRight: `1px solid ${borderColor}`,
            borderLeft: downloadRevenuesData?.primary_details?.irn ? "" : `1px solid ${borderColor}`,
            borderBottom: `1px solid ${borderColor}`,
            flex: 1,
            padding: 8,

          }]}
        >

          <Text style={{ ...styles.sub_header, color: "#dd4433" }}>
            Shipping Address :
          </Text>

          {downloadRevenuesData?.primary_details?.ship_to_address ? (
            <View>
              <Text style={styles.text}>
                {downloadRevenuesData?.primary_details?.ship_to_address}
              </Text>
            </View>
          ) : <Text style={[styles.text, { marginBottom: 3 }]}>
            NA
          </Text>}

          {downloadRevenuesData?.primary_details?.place_of_supply?.label?.split(
            "-"
          )[0]?.length ? (
            <Text style={styles.flexCenter}>
              <Text style={styles.sub_header}>State/UT Code: </Text>
              <Text style={styles.text}>
                {
                  downloadRevenuesData?.primary_details?.place_of_supply?.label?.split(
                    "-"
                  )[0]
                }
              </Text>
            </Text>
          ) : null}

          {downloadRevenuesData?.primary_details?.place_of_supply?.value ? (
            <Text style={styles.flexCenter}>
              <Text style={styles.sub_header}>Place of supply : </Text>
              <Text style={styles.text}>
                {
                  downloadRevenuesData?.primary_details?.place_of_supply
                    ?.value
                }
              </Text>
            </Text>
          ) : null}

          {downloadRevenuesData?.primary_details?.voucher_invoice_number ? (
            <Text style={styles.flexCenter}>
              <Text style={styles.sub_header}>Invoice Number : </Text>
              <Text style={styles.text}>
                {
                  downloadRevenuesData?.primary_details
                    ?.voucher_invoice_number
                }
              </Text>
            </Text>
          ) : null}

          {downloadRevenuesData?.primary_details?.voucher_invoice_date ? (
            <Text style={styles.flexCenter}>
              <Text style={styles.sub_header}>Invoice Date : </Text>

              <Text style={styles.text}>
                {formatDate(
                  downloadRevenuesData?.primary_details?.voucher_invoice_date
                )}
              </Text>
            </Text>
          ) : null}



          {downloadRevenuesData?.primary_details?.due_date ? (
            <Text style={styles.flexCenter}>
              <Text style={styles.sub_header}>Due Date : </Text>

              <Text style={styles.text}>
                {formatDate(downloadRevenuesData?.primary_details?.due_date)}
              </Text>
            </Text>
          ) : null}
        </View>
      </View>}


    </View >
  );
};

export default BatchSummaryFromAndLogo;